import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button as MuiButton, Alert, Link, Stack, Typography, Box } from '@mui/material';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

export default function ReferAndEarnPopup({
  open,
  onClose,
  onConfirm,
  loading,
  theme,
  translate
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{
        background: theme.palette.primary.main,
        color: '#fff',
        fontWeight: 700,
        letterSpacing: 0.5,
        textAlign: 'center',
        pb: 2,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
          <CardGiftcardIcon sx={{ color: '#fff', fontSize: 28 }} />
          <span>Refer and Earn</span>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ background: '#fffbe6', borderBottomLeftRadius: 8, borderBottomRightRadius: 8, p: 5, minHeight: 420, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ maxWidth: 700, width: '100%' }}>
          <Alert icon={<CardGiftcardIcon />} severity="info" sx={{ mt:2, mb: 2, background: '#fff3cd', color: '#795548', fontWeight: 500, border: 'none' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: theme.palette.primary.main,  mb: 0.5 }}>
              Invite & Earn 50%!
            </Typography>
            <Typography variant="body2" sx={{ color: '#795548' }}>
              Share your unique referral link and earn <b>50% of your friend's payment every month</b> (recurring), not just the first payment!
            </Typography>
          </Alert>
          <Stack spacing={2}>
            <Box sx={{ background: '#fff', borderRadius: 2, p: 3, boxShadow: '0 1px 6px 0 #ffe082' }}>
              <Typography variant="subtitle2" sx={{ color: theme.palette.primary.main, fontWeight: 600, mb: 1 }}>
                How it works
              </Typography>
              <Stack component="ul" spacing={1} sx={{ pl: 2, m: 0 }}>
                <li>
                  <Typography variant="body2">
                    <b>50% Commission:</b> Earn 50% of your referred user's payment every month, recurring on the 10th of each month, for as long as they remain subscribed.
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <b>365 Days Cookie Policy:</b> If your referral signs up within 365 days of clicking your link, you get the reward.
                  </Typography>
                </li>
              </Stack>
            </Box>
            <Typography variant="body2" sx={{ color: '#333', textAlign: 'center' }}>
              To refer and earn, click the button below. Our team will contact you with more details and provide your unique referral link.
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
              For queries, email us at{' '}
              <Link href="mailto:admin@brand2social.com" underline="hover" color="primary">
                admin@brand2social.com
              </Link>
            </Typography>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', background: '#fffbe6', borderBottomLeftRadius: 8, borderBottomRightRadius: 8, pb: 2 }}>
        <MuiButton
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{
            minWidth: 100,
            fontWeight: 600,
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            background: '#fff',
            '&:hover': {
              background: theme.palette.primary.light,
              borderColor: theme.palette.primary.dark,
              color: theme.palette.primary.dark,
            },
            mr: 2
          }}
        >
          Cancel
        </MuiButton>
        <MuiButton
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={loading}
          sx={{
            minWidth: 140,
            fontWeight: 700,
            background: theme.palette.primary.main,
            color: '#fff',
            boxShadow: '0 2px 8px 0 rgba(255, 193, 7, 0.15)',
            '&:hover': {
              background: theme.palette.primary.dark,
              color: '#fff',
            },
          }}
        >
          {loading ? (translate('common.sending') || 'Sending...') : 'Send Request'}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
}
